import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M31.813 20.14v-.139c0-4.412-3.588-8.001-8-8.001a8.02 8.02 0 0 0-6.781 3.76 6.224 6.224 0 0 0-7.49 4.1 4.077 4.077 0 0 0-3.935 4.069C5.607 26.127 7.433 28 9.678 28q.09 0 .192-.005a.4.4 0 0 0 .068.005H22.12a.44.44 0 1 0 0-.88H10.037a.5.5 0 0 0-.126-.009 3.195 3.195 0 0 1-3.424-3.183 3.196 3.196 0 0 1 2.837-3.171 6.3 6.3 0 0 0-.083 1.022.44.44 0 1 0 .879 0c0-.461.058-.917.174-1.358q.002-.006.003-.007a5.344 5.344 0 0 1 6.805-3.718q.003 0 .01.002a5.4 5.4 0 0 1 3.087 2.61.44.44 0 0 0 .594.186.44.44 0 0 0 .186-.593 6.28 6.28 0 0 0-3.088-2.848 7.14 7.14 0 0 1 5.925-3.173c3.894 0 7.067 3.143 7.119 7.026a4.1 4.1 0 0 0-1.493.048.44.44 0 1 0 .19.86 3.2 3.2 0 0 1 1.605.058 3.21 3.21 0 0 1 2.28 3.058 3.195 3.195 0 0 1-3.192 3.193h-5.377a.44.44 0 1 0 0 .879h5.377a4.076 4.076 0 0 0 4.071-4.072 4.1 4.1 0 0 0-2.581-3.789z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }